import { isEmpty } from 'lodash';

import { invertObject } from './common';
import { RIGHTS } from '../constants';


function getUserPossibleTransitions(rightsDat, rightsJson) {
  const userPossibleTransitions = {};
  
  if (isEmpty(rightsDat) || isEmpty(rightsJson.users)) {
    return userPossibleTransitions;
  }
  
  const rightsInverted = invertObject(rightsJson.rights);
  const rightsToCount = [
    rightsInverted[RIGHTS.WRITE],
    rightsInverted[RIGHTS.REVIEW],
    rightsInverted[RIGHTS.LOCK]
  ].map(strNum => Number(strNum));
  
  // add rights count to userPossibleTransitions object
  rightsDat.forEach(row => {
    const [user, projectPath, rightCode, stepRightsCount] = row;
    if (!userPossibleTransitions[user]) {
      userPossibleTransitions[user] = {};
    };
    if (rightsToCount.includes(rightCode)) {
      if (!userPossibleTransitions[user][projectPath]) {
        userPossibleTransitions[user][projectPath] = rightsToCount.reduce(
          // eslint-disable-next-line no-param-reassign
          (obj, right) => {obj[right] = 0; return obj;}, {}
        )
      };
      userPossibleTransitions[user][projectPath][rightCode] = stepRightsCount;
    }
  });

  return userPossibleTransitions;
};

export default getUserPossibleTransitions;
